export const LABEL_PANEL_WIDTH = 620;
